import React from 'react'

import { reverse } from 'named-urls'
import { useHistory, useLocation } from 'react-router-dom'

import { Paper, Box } from '@material-ui/core'

import UserDisable from './components/UserDisable'
import { routes } from 'routes'
import { Container, ContentHeader } from 'components'
import * as service from 'service'
import UsersForm from './components/UsersForm'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

const UsersEdit = ({ match }) => {
  const { userId } = match.params
  const location = useLocation()
  const history = useHistory()
  const snackbar = useSnackbar()

  const { response, isLoading, refresh } = useFetch(
    service.recurrence.users.get,
    {
      userId,
    },
  )

  const handleStatusChange = () => {
    refresh()
  }

  const data = React.useMemo(() => {
    if (!response) {
      return
    }

    return {
      ...response.data.user,
      profileId: response.data.user.profile.id,
      ...(location.state && location.state.fromProfiles
        ? {
            ...location.state.user,
            ...(location.state.profile
              ? { profileId: location.state.profile.id }
              : {}),
          }
        : {}),
    }
  }, [response, location])

  const handleSubmit = async user => {
    try {
      await service.recurrence.users.put({
        userId,
        user,
      })

      snackbar.open({
        message: 'Usuário atualizado com sucesso!',
        variant: 'success',
      })

      history.push({
        pathname: reverse(routes.settings.all),
        state: { value: 5 },
      })
    } catch (error) {
      const errorMessage =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.message

      snackbar.open({
        message: `Falha ao atualizar usuário! ${errorMessage}`,
        variant: 'error',
      })

      history.push({
        pathname: reverse(routes.settings.all),
        state: { value: 5 },
      })
    }
  }

  return (
    <Container>
      <ContentHeader title="Usuário" subtitle="Editar" />
      {isLoading && !data ? (
        <Paper>
          <Box p={2}></Box>
        </Paper>
      ) : (
        <>
          <UsersForm userId={userId} data={data} onSubmit={handleSubmit} />

          <Box my={4}>
            <UserDisable
              userId={data.id}
              active={data.active}
              onStatusChange={handleStatusChange}
            />
          </Box>
        </>
      )}
    </Container>
  )
}

export default UsersEdit
